<template>
  <div class="item-finacnce" @click="goToDaly">
    <div class="date">{{date}}</div>
    <div class="income">收入：{{ incomeOff }}</div>
    <div class="pay">支出：<span>{{ paymentOff }}</span></div>
    <van-icon class="item-icon" name="arrow" color="#666" />
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";

Vue.use(Icon);

export default {
  name: "FinaceItem",
  props:{
      date:String,
      incomeOff:Number,
      paymentOff:Number
  },
  computed: {
  },
 mounted() {
  },
  methods: {
    goToDaly(){
      this.$router.push({path:'/ShopFinanceDaly',query: {date:this.date}})
    }
  },
};
</script>

<style lang="scss">
.item-finacnce {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  min-height: 40px;
  align-items: center;
  box-shadow: 1px 1px 3px #dedede;
  text-align: left;
  .date{
    min-width: 100px;
    color: #666666;
    font-weight: bold;
  }
  .income{
    min-width: 100px;
    color: #333333;
    font-weight: bold;
  }
  .pay{
    min-width: 100px;
    font-weight: bold;
    span{
      color: #ff3366;
    }
  }
  .item-icon{
    position: relative;
    right: 10px;
  }
}
</style>
